import { call, takeLatest, put } from 'redux-saga/effects';
import { AppAction } from './enum';
import { initAvailability, initOverlay, initProductDetails, initStateFromQuery, initTracking, setPageQueryParams } from './generator';
import { initApp, setError, setLoading, setOverlayVisibility, setSelectedGigakombi, setSelectedProduct } from './action';
import { debugInfo } from '@vfde-sails/utils';
import { trackErrorHandler, trackForm, trackGigakombi, trackPageView } from '../../tracking/generator';
import { Gigakombi, OverlayView } from '../../enum';
import { TrackingFormStepName } from '@vfde-sails/tracking';
import { isGigaKombi } from '../../util/typeGuard';
import { initLoginSaga, LoginAction, setCustomer } from '@vfde-sails/login';

export function* initAppSaga (action: ReturnType<typeof initApp>) {
    try {
        yield put(setLoading(true));

        yield call(initStateFromQuery);
        yield call(initOverlay, action.overlay);
        yield call(initLoginSaga);
        yield call(initProductDetails);
        yield call(initAvailability);
        yield call(initTracking);
    } catch (error) {
        yield call(debugInfo, error);
        yield put(setError(error));
        yield call(trackErrorHandler, error);
    } finally {
        yield put(setLoading(false));
    }
}

export function* overlaySaga (action: ReturnType<typeof setOverlayVisibility>) {
    if (action.value !== OverlayView.AVAILABILITY_FORM) {
        return;
    }

    yield call(trackForm, TrackingFormStepName.Show);
}

export function* setSelectedProductSaga (action: ReturnType<typeof setSelectedProduct>) {
    yield call(setPageQueryParams);

    if (action.shouldTrack) {
        yield call(trackPageView);
    }
}

export function* setSelectedGigakombiSaga (action: ReturnType<typeof setSelectedGigakombi>) {
    if (!isGigaKombi(action.gigakombi) || !action.shouldTrack) {
        return;
    }

    yield call(trackGigakombi);
    yield call(setPageQueryParams);
}

export function* setCustomerSaga (action: ReturnType<typeof setCustomer>) {
    const gigakombi = action.customer.hasKipContract
        ? Gigakombi.INTERNET
        : Gigakombi.NONE;

    yield put(setSelectedGigakombi(gigakombi, false));
}

export default function* appSaga () {
    yield takeLatest(AppAction.INIT_APP, initAppSaga);
    yield takeLatest(AppAction.SET_OVERLAY_VISIBILITY, overlaySaga);
    yield takeLatest(AppAction.SET_SELECTED_PRODUCT, setSelectedProductSaga);
    yield takeLatest(AppAction.SET_SELECTED_GIGAKOMBI, setSelectedGigakombiSaga);
    yield takeLatest(LoginAction.SetCustomer, setCustomerSaga);
}
